export default __webpack_public_path__ + "static/media/google.06c45134.svg";